import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ImageUrlPipe } from 'app/modules/admin/pipe/image-url.pipe';

@Component({
  selector: 'app-edit-user',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule,ImageUrlPipe],
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {
  userForm: FormGroup;
  isLoading: boolean = false;
  isSubmitting: boolean = false;
  selectedFileName: string = '';
  imagePreview: string | null = null;
  selectedFile: File | null = null;
  currentUser: any = null;
  userCode: string = '';
  showChangePassword: boolean = false; // إضافة متغير للتحكم في الظهور

  constructor(
    private fb: FormBuilder,
    //private userService: UserService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.userForm = this.createForm();
  }

  ngOnInit() {
    this.userCode = this.route.snapshot.paramMap.get('code') || '';
    if (this.userCode) {
      this.loadUserData();
    } else {
      alert('User code not found');
      this.router.navigateByUrl('/admin/users');
    }
  }

  createForm(): FormGroup {
    return this.fb.group({
      code: ['', [Validators.required, Validators.minLength(2)]],
      type: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      password: [''],
      confirmPassword: [''],
      phone: ['', [
        Validators.required, 
        Validators.minLength(11),
        Validators.maxLength(11),
        this.egyptPhoneValidator
      ]],
      avatar: [null],
      banned: [false],
      status: [true]
    }, {
      validators: [this.conditionalPasswordValidator.bind(this)]
    });
  }

  loadUserData() {
    this.isLoading = true;/////////////////////////
    
    // this.userService.getUserById(this.userCode).subscribe({
    //   next: (response) => {
    //     this.currentUser = response.data;
    //     this.populateForm(this.currentUser);
    //     this.isLoading = false;
    //   },
    //   error: (error) => {
    //     console.error('Error loading user data:', error);
    //     this.isLoading = false;
    //     alert('Failed to load user data');
    //     this.router.navigateByUrl('/admin/users');
    //   }
    // });
    this.isLoading = false;/////////////////////////

  }

  populateForm(user: any) {
    this.userForm.patchValue({
      code: user.code || '',
      type: user.type || '',
      name: user.name || '',
      email: user.email || '',
      phone: user.phone || '',
      banned: user.banned || false,
      status: user.status !== undefined ? user.status : true
    });

    // تحميل الصورة الحالية إذا كانت موجودة
    if (user.avatar) {
      this.imagePreview = user.avatar;
      this.selectedFileName = 'Current avatar';
    }

    // نتبع تغييرات كلمة المرور والتأكيد علشان نحدث الفاليديشن
    this.userForm.get('password')?.valueChanges.subscribe(() => {
      this.userForm.get('confirmPassword')?.updateValueAndValidity();
    });

    this.userForm.get('confirmPassword')?.valueChanges.subscribe(() => {
      this.userForm.get('confirmPassword')?.updateValueAndValidity();
    });
  }
// دالة للتحكم في ظهور قسم تغيير الباسورد
  toggleChangePassword() {
    this.showChangePassword = !this.showChangePassword;
    
    if (!this.showChangePassword) {
      // إذا تم إخفاء القسم، نمسح حقلي الباسورد
      this.userForm.patchValue({
        password: '',
        confirmPassword: ''
      });
      
      // نمسح الأخطاء من حقلي الباسورد
      this.userForm.get('password')?.setErrors(null);
      this.userForm.get('confirmPassword')?.setErrors(null);
      this.userForm.updateValueAndValidity();
    }
  }

  // Custom validator للتحقق من تطابق كلمات المرور (مشروط)
  conditionalPasswordValidator(control: AbstractControl): ValidationErrors | null {
    // إذا قسم تغيير الباسورد مش ظاهر، متعملش فاليديشن
    if (!this.showChangePassword) {
      return null;
    }

    const password = control.get('password');
    const confirmPassword = control.get('confirmPassword');

    if (!password || !confirmPassword) {
      return null;
    }

    // إذا كان الباسورد فارغ، معناه المستخدم مش عايز يغير الباسورد
    if (!password.value && !confirmPassword.value) {
      return null;
    }

    // إذا واحد فيهم مليان والتاني لا
    if ((password.value && !confirmPassword.value) || (!password.value && confirmPassword.value)) {
      return { passwordRequired: 'Both password fields are required' };
    }

    // إذا الاتنين مليانين بس مش متطابقين
    if (password.value && confirmPassword.value && password.value !== confirmPassword.value) {
      return { passwordMismatch: true };
    }

    // إذا الاتنين مليانين وطوله أقل من 6
    if (password.value && password.value.length < 6) {
      password.setErrors({ minlength: { requiredLength: 6, actualLength: password.value.length } });
      return { passwordMinLength: true };
    }

    return null;
  }
  
  // Custom validator للتحقق من رقم الهاتف المصري
  egyptPhoneValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const phone = control.value.toString().trim();
    
    // التحقق من أنه رقم
    if (!/^\d+$/.test(phone)) {
      return { phoneNotNumber: 'Phone number must contain only digits' };
    }
    
    // التحقق من أنه يبدأ بـ 01
    if (!phone.startsWith('01')) {
      return { phoneStartWith01: 'Phone number must start with 01' };
    }
    
    // التحقق من الطول
    if (phone.length !== 11) {
      return { phoneLength: 'Phone number must be exactly 11 digits' };
    }
    
    // التحقق من أن الرقم الثالث يكون 0, 1, 2, 5 (شركات المحمول في مصر)
    const thirdDigit = phone[2];
    if (!['0', '1', '2', '5'].includes(thirdDigit)) {
      return { phoneOperator: 'Invalid phone operator' };
    }
    
    return null;
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      const validTypes = ['image/jpeg', 'image/png', 'image/webp'];
      if (!validTypes.includes(file.type)) {
        alert('Please select a valid image file (JPG, PNG, WebP)');
        return;
      }

      // Validate file size (2MB max)
      if (file.size > 2 * 1024 * 1024) {
        alert('File size must be less than 2MB');
        return;
      }

      this.selectedFile = file;
      this.selectedFileName = file.name;
      this.userForm.patchValue({ avatar: file });

      // Create preview
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  removeImage() {
    this.selectedFile = null;
    this.selectedFileName = '';
    this.imagePreview = null;
    this.userForm.patchValue({ avatar: '' });
  }

  generatePassword() {
    const length = 12;
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
    let password = "";
    
    for (let i = 0; i < length; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    
    this.userForm.patchValue({
      password: password,
      confirmPassword: password
    });

    // نحدث الفاليديشن بعد توليد الباسورد
    this.userForm.get('confirmPassword')?.updateValueAndValidity();
  }

  async onSubmit() {
    if (this.userForm.invalid) {
      this.markAllFieldsAsTouched();
      return;
    }

    this.isSubmitting = true;

    try {
      const formData = this.userForm.value;
      console.log(formData);
      // this.userService.updateUser(this.userId, formData).subscribe({
      //   next: (response) => {
      //     this.isSubmitting = false;
      //     alert('✅ User updated successfully!');
      //     this.router.navigateByUrl('/admin/users');
      //   },
      //   error: (error) => {
      //     this.isSubmitting = false;
      //     console.error('❌ Error updating user:', error);
          
      //     if (error.status === 409) {
      //       alert('⚠️ User with this email or code already exists');
      //     } else {
      //       alert('⚠️ Failed to update user. Please try again.');
      //     }
      //   }
      // });
    } catch (error) {
      this.isSubmitting = false;
      console.error('❌ Error preparing form data:', error);
      alert('⚠️ Error preparing form data. Please check your inputs.');
    }
  }

  prepareFormData(): FormData {
    const formValue = this.userForm.value;
    const formData = new FormData();

    // Append all form fields except password confirmation and avatar
    Object.keys(formValue).forEach(key => {
      if (key !== 'confirmPassword' && key !== 'avatar') {
        // إذا الباسورد فارغ، متبعتهوش (متحطش الباسورد)
        if (key === 'password' && !formValue[key]) {
          return;
        }
        formData.append(key, formValue[key]);
      }
    });

    // Append avatar file if selected
    if (this.selectedFile) {
      formData.append('avatar', this.selectedFile);
    } else if (!this.imagePreview && formValue.avatar === '') {
      // إذا تم حذف الصورة
      formData.append('removeAvatar', 'true');
    }

    return formData;
  }

  markAllFieldsAsTouched() {
    Object.keys(this.userForm.controls).forEach(key => {
      this.userForm.get(key)?.markAsTouched();
    });
  }

  showError(controlName: string): boolean {
    const control = this.userForm.get(controlName);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  getError(controlName: string): string {
    const control = this.userForm.get(controlName);
    if (control?.errors) {
      if (control.errors['required']) return 'This field is required';
      if (control.errors['email']) return 'Please enter a valid email address';
      if (control.errors['minlength']) return `Minimum length is ${control.errors['minlength'].requiredLength} characters`;
      if (control.errors['passwordMismatch']) return 'Passwords do not match';
      if (control.errors['passwordRequired']) return control.errors['passwordRequired'];
      if (control.errors['passwordMinLength']) return 'Password must be at least 6 characters long';
      
      // أخطاء الهاتف
      if (control.errors['phoneNotNumber']) return control.errors['phoneNotNumber'];
      if (control.errors['phoneStartWith01']) return control.errors['phoneStartWith01'];
      if (control.errors['phoneLength']) return control.errors['phoneLength'];
      if (control.errors['phoneOperator']) return control.errors['phoneOperator'];
    }
    return 'Invalid value';
  }

  // دالة جديدة للتحقق من إيرور تطابق الباسورد على مستوى الفورم
  showPasswordMismatchError(): boolean {
    return !!this.userForm.errors?.['passwordMismatch'] && 
           this.userForm.get('password')?.touched && 
           this.userForm.get('confirmPassword')?.touched;
  }

  // دالة للتحقق إذا كانت هناك تغييرات في الفورم
  hasChanges(): boolean {
    if (!this.currentUser) return false;
    
    const formValue = this.userForm.value;
    return (
      formValue.code !== this.currentUser.code ||
      formValue.type !== this.currentUser.type ||
      formValue.name !== this.currentUser.name ||
      formValue.email !== this.currentUser.email ||
      formValue.phone !== this.currentUser.phone ||
      formValue.banned !== this.currentUser.banned ||
      formValue.status !== this.currentUser.status ||
      (formValue.password && formValue.password !== '') ||
      this.selectedFile !== null
    );
  }

  goBack() {
    this.router.navigateByUrl('/admin/users');
  }
}